import { ButtonPosition } from '@/common/manager/position/button-position';
import isEmpty from 'lodash/isEmpty';
export const config = {
    value: 'arrayTableMoveDown',
    position: [ButtonPosition.arrayTableOperate],
    action: (config = {}) => {
        // 该函数只在动作编排里执行
        // 非动作编排是个功能组件
        try {
            const { field } = config;
            const { indexes } = field;
            if (isEmpty(indexes))
                return;
            const index = Number(indexes[0]);
            const arrayLength = field.parent.value.length;
            const isLast = index === arrayLength - 1;
            if (isLast || isNaN(index))
                return;
            field.parent.moveDown(index);
        }
        catch (e) {
            console.error('movedown failed', e);
        }
    },
};
